import { OUT_OF_MENU_ENDPOINT, PRICE_CHANGE_LIST_ENDPOINT, PRINT_MENU_ENDPOINT } from '@dynameat/constants';
import axios from 'axios';

export const outOfMenuRequest = (posGuid, startDate, endDate) => axios.get(OUT_OF_MENU_ENDPOINT(posGuid),
  { params: { start_date: startDate, end_date: endDate } });

export const exportPriceChangesRequest = (posGuid, startDate, endDate) => axios.get(PRICE_CHANGE_LIST_ENDPOINT(posGuid),
  { params: { start_date: startDate, end_date: endDate } });

export const printMenuRequest = (menuGuid, selectDay, saleZoneGuid, serviceGuid, languageGuid, selectedSections) => axios.get(PRINT_MENU_ENDPOINT(menuGuid),
  {
    params: {
      select_day: selectDay, sale_zone_guid: saleZoneGuid, service_guid: serviceGuid, language_guid: languageGuid, selected_sections: selectedSections
    },
  });
